import { useCallback } from "react";
import { useRouter } from "next/router";
import { useModal } from "@/hooks";
import { Button } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import modalStyles from "@/styles/Modal.module.scss";

export default function LogoutModal() {
  const router = useRouter();
  const { hideModal } = useModal();
  const logout = useCallback(() => {
    hideModal();
    router.push(routes.logout);
  }, []);

  return (
    <div className={modalStyles.logout}>
      <p className={modalStyles.text}>ログアウトしますか？</p>
      <div className={modalStyles.buttons}>
        <Button
          type="button"
          fillColor
          large
          fillGray
          borderGray
          onClick={hideModal}
        >
          キャンセル
        </Button>
        <Button type="button" fillColor large onClick={logout}>
          ログアウト
        </Button>
      </div>
    </div>
  );
}
